export default __webpack_public_path__ + "878a1ee4a96c1ffbada88e8ea3866dfa.png";